@if (versionId) {
<div class="modules-card">
  <!-- Card header -->
  <div class="card-header">
    <div>
      <h3 class="section-title">Moduler</h3>
      @if (versionName) {
      <p class="version-label">{{ versionName }}</p>
      }
    </div>
  </div>
  <!-- Year filter (shared by both tabs) + optional version period -->
  @if (versionId) {
  <div class="period-banner">
    <div class="year-filter-wrap">
      <span class="year-filter-prefix">År</span>
      <mat-form-field
        appearance="outline"
        class="year-filter-field"
        subscriptSizing="dynamic"
      >
        <mat-select
          [(ngModel)]="selectedModuleYear"
          (ngModelChange)="onModuleYearChange($event)"
          [panelWidth]="null"
          panelClass="duna-year-select-panel"
          [disableOptionCentering]="true"
          aria-label="Vælg år for moduler"
        >
          @for (y of moduleYearOptions; track y) {
          <mat-option [value]="y">{{ y }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (currentPeriodStart && currentPeriodEnd) {
    <div class="period-banner-left">
      <span class="period-icon">📅</span>
      <div>
        <span class="period-banner-title">Vedligeholdelsesrul</span>
        <span class="period-banner-dates">{{ formatPeriodRange() }}</span>
        @if (viewRollYearsLabel) {
        <span class="period-banner-years">· År i rul: {{ viewRollYearsLabel }}</span>
        }
      </div>
    </div>
    }
    @if (inheritsMaintenanceFromPathName) {
    <div class="inherit-banner">
      <span class="inherit-banner-title">Arvet vedligeholdelse</span>
      <span class="inherit-banner-text">
        Moduler fra
        <strong>{{ inheritsMaintenanceFromPathName }}</strong>
        @if (inheritsMaintenanceFromVersionName) {
        <span> ({{ inheritsMaintenanceFromVersionName }})</span>
        }
        vises som læsbare rækker. Egne moduler kan stadig tilføjes og redigeres her.
      </span>
    </div>
    }
    @if (currentPeriodStart && currentPeriodEnd) {
    <div class="filter-toggle">
      <button
        mat-button
        [class.active]="!filterActiveOnly"
        (click)="filterActiveOnly = false"
      >
        Vis alle (rul)
      </button>
      <button
        mat-button
        [class.active]="filterActiveOnly"
        (click)="filterActiveOnly = true"
      >
        Kun aktive i rul
      </button>
    </div>
    }
  </div>
  }
  <mat-tab-group animationDuration="0ms">
    <!-- ──── Vedligeholdelse ──────────────────────────────────────────────── -->
    <mat-tab label="Vedligeholdelse">
      <div class="tab-content">
        <!-- Toolbar -->
        <div class="toolbar">
          <button
            mat-raised-button
            color="primary"
            (click)="onAddMaintenance()"
          >
            + Tilføj vedligeholdelse
          </button>
        </div>
        @if (loadingMaintenance) {
        <p class="loading-message">Henter vedligeholdelse...</p>
        } @if (!loadingMaintenance && maintenanceByModule.length > 0) {
        <!-- Summary bar -->
        <div class="summary-bar">
          <span class="summary-count">
            {{ filteredMaintenanceGroups.length }}
            @if (maintenanceSearch) { af {{ maintenanceByModule.length }} }
            modul{{ maintenanceByModule.length === 1 ? "" : "er" }}
          </span>
          @if (currentPeriodStart && currentPeriodEnd) {
          <span class="summary-active">
            · {{ maintenanceActiveCount }} aktive i rul
          </span>
          }
          <div class="summary-actions">
            <button
              mat-button
              class="summary-btn"
              (click)="
                expandAll(filteredMaintenanceGroups, expandedMaintenance)
              "
            >
              Udvid alle
            </button>
            <button
              mat-button
              class="summary-btn"
              (click)="collapseAll(expandedMaintenance)"
            >
              Fold alle ind
            </button>
          </div>
        </div>
        <!-- Search -->
        <div class="search-bar">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Søg i vedligeholdelse</mat-label>
            <input
              matInput
              [(ngModel)]="maintenanceSearch"
              (ngModelChange)="onMaintenanceSearchChange()"
              placeholder="Modulnavn..."
            />
            @if (maintenanceSearch) {
            <span
              matSuffix
              class="search-clear"
              (click)="maintenanceSearch = ''; onMaintenanceSearchChange()"
              >✕</span
            >
            }
          </mat-form-field>
        </div>
        <!-- No search results -->
        @if (filteredMaintenanceGroups.length === 0) {
        <p class="empty-message">
          Ingen moduler matcher "{{ maintenanceSearch }}".
        </p>
        }
        <!-- Module cards -->
        @for (group of paginatedMaintenanceGroups; track trackByKey($index,
        group); let gi = $index) {
        @if (showInheritedMaintenanceSectionHeader(gi)) {
        <h4 class="maintenance-section-title maintenance-section-inherited">
          Arvet fra anden uddannelsesvej
        </h4>
        <p class="maintenance-section-hint">
          Disse moduler kommer fra den version, du har valgt under
          «Arv vedligeholdelse». De kan ikke redigeres her — kun læses.
        </p>
        }
        @if (showOwnMaintenanceSectionHeader(group, gi)) {
        <h4 class="maintenance-section-title">Egne vedligeholdelsesmoduler</h4>
        }
        <div
          class="module-group-card"
          [class.has-current-coverage]="
            group.hasCurrentPeriodCoverage && !isInheritedOnlyGroup(group)
          "
          [class.inherited-group]="isInheritedOnlyGroup(group)"
          [class.has-mixed-inherited]="
            groupHasInheritedEntries(group) && !isInheritedOnlyGroup(group)
          "
        >
          <!-- Clickable header row (toggle expand) -->
          <div
            class="group-header"
            (click)="toggleExpand(group.key, expandedMaintenance)"
          >
            <div class="group-header-left">
              <span class="expand-icon">{{
                isExpanded(group.key, expandedMaintenance) ? "▾" : "▸"
              }}</span>
              <span class="group-name">{{ group.name }}</span>
              <span class="type-chip">{{ group.itemType || group.type }}</span>
              @if (
                group.hasCurrentPeriodCoverage && !isInheritedOnlyGroup(group)
              ) {
              <span class="active-chip">Aktiv nu</span>
              }
              @if (isInheritedOnlyGroup(group)) {
              <span class="inherit-header-chip">Arvet</span>
              } @else if (groupInheritedSourceLabel(group); as src) {
              <span class="inherit-header-chip partial" [title]="src"
                >Indeholder arvet</span
              >
              }
            </div>
            <div class="group-header-meta">
              @if (maintenanceHeaderMinutesLabelForYearFilter(group); as
              minLabel) {
              <span class="group-header-minutes">{{ minLabel }}</span>
              } @if (maintenanceHeaderRequiredDisplay(group); as reqHdr) {
              <span class="group-header-req-badge" [ngClass]="reqHdr.kind">{{
                reqHdr.text
              }}</span>
              } @if (groupItemDescriptionText(group); as descText) {
              <span class="group-header-desc" [title]="descText">{{
                descText
              }}</span>
              }
            </div>
            <div class="group-header-right">
              <ng-container
                *ngTemplateOutlet="coverageChips; context: { $implicit: group }"
              ></ng-container>
              <span class="entry-count"
                >{{ group.entries.length }}
                {{ group.entries.length === 1 ? "periode" : "perioder" }}</span
              >
            </div>
          </div>
          <!-- Expanded content -->
          @if (isExpanded(group.key, expandedMaintenance)) {
          <!-- Entries list -->
          <div class="entries-list">
            @for (row of group.entries; track trackById($index, row)) {
            <div
              class="entry-row"
              [class.entry-inherited]="isInheritedMaintenance(row)"
              [class.entry-active]="
                !isInheritedMaintenance(row) &&
                isActiveInCurrentPeriod(row.start_date, row.end_date)
              "
            >
              @if (editingMaintenanceId !== row.id) {
              <div class="entry-main">
                <div class="entry-info">
                  @if (
                    !isInheritedMaintenance(row) &&
                    isActiveInCurrentPeriod(row.start_date, row.end_date)
                  ) {
                  <span class="entry-active-dot" title="Aktiv i rul"
                    >●</span
                  >
                  }
                  <span class="entry-dates">{{
                    formatDateRange(row.start_date, row.end_date)
                  }}</span>
                  @if (row.required) {
                  <span class="req-badge req">Påkrævet</span>
                  } @if (!row.required) {
                  <span class="req-badge opt">Valgfri</span>
                  } @if (row.maintenance_minutes != null) {
                  <span class="entry-minutes"
                    >{{ row.maintenance_minutes }} min</span
                  >
                  }
                </div>
                @if (inheritedMaintenanceLabel(row); as inheritLabel) {
                <p class="entry-inherit-source">
                  {{ inheritLabel }} — kan kun ændres på kilde-versionen
                </p>
                }
              </div>
              @if (!isInheritedMaintenance(row)) {
              <div class="entry-actions">
                <button
                  mat-button
                  class="btn-edit"
                  (click)="openEditMaintenance(row, group.key)"
                >
                  Rediger
                </button>
                <button
                  mat-button
                  class="btn-remove"
                  (click)="removeMaintenance(row)"
                >
                  Fjern
                </button>
              </div>
              }
              } @else {
              <div class="inline-edit-form">
                <mat-form-field appearance="outline" class="date-field">
                  <mat-label>Start dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="editForm.start_date"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="date-field">
                  <mat-label>Slut dato</mat-label>
                  <input matInput type="date" [(ngModel)]="editForm.end_date" />
                </mat-form-field>
                <label class="checkbox-label">
                  <input type="checkbox" [(ngModel)]="editForm.required" />
                  Påkrævet
                </label>
                <div class="form-actions">
                  <button mat-button (click)="cancelEditMaintenance()">
                    Annuller
                  </button>
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="saveEditMaintenance()"
                  >
                    Gem
                  </button>
                </div>
              </div>
              }
            </div>
            }
          </div>
          <!-- Inline add period -->
          <div class="inline-add-section">
            @if (addingPeriodForKey === group.key) {
            <div class="inline-add-form">
              <span class="inline-add-label"
                >Ny periode for <strong>{{ group.name }}</strong></span
              >
              <mat-form-field appearance="outline" class="date-field">
                <mat-label>Start dato</mat-label>
                <input
                  matInput
                  type="date"
                  [(ngModel)]="inlineAddForm.start_date"
                  required
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="date-field">
                <mat-label>Slut dato</mat-label>
                <input
                  matInput
                  type="date"
                  [(ngModel)]="inlineAddForm.end_date"
                />
              </mat-form-field>
              <label class="checkbox-label">
                <input type="checkbox" [(ngModel)]="inlineAddForm.required" />
                Påkrævet
              </label>
              <div class="form-actions">
                <button mat-button (click)="cancelInlineAddMaintenance()">
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!inlineAddForm.start_date || savingInlineAdd"
                  (click)="saveInlineAddMaintenance(group)"
                >
                  {{ savingInlineAdd ? "Gemmer..." : "Tilføj periode" }}
                </button>
              </div>
            </div>
            } @else if (!isInheritedOnlyGroup(group)) {
            <button
              mat-button
              class="add-period-btn"
              (click)="openInlineAddMaintenance(group)"
            >
              + Tilføj periode for dette modul
            </button>
            } @else {
            <p class="inline-add-inherited-hint">
              Tilføj egne perioder ved at oprette moduler på denne version, eller
              rediger på kilde-versionen.
            </p>
            }
          </div>
          }
        </div>
        } @if (maintenanceFilteredYearTotals; as allMinutes) {
        <div class="maintenance-year-totals-summary">
          <span class="maintenance-year-totals-label"
            >{{ viewRollSummaryLabel }}</span
          >
          <span class="maintenance-year-totals-sep">·</span>
          <span
            >{{ formatMaintenanceMinutes(allMinutes.required) }} påkrævet</span
          >
          <span class="maintenance-year-totals-sep">·</span>
          <span
            >{{ formatMaintenanceMinutes(allMinutes.optional) }} valgfri</span
          >
          <span class="maintenance-year-totals-sep">·</span>
          <span class="maintenance-year-totals-total"
            >{{ formatMaintenanceMinutes(allMinutes.total) }} i alt</span
          >
        </div>
        }
        <!-- Pagination (Vedligeholdelse) -->
        @if (maintenanceGroupsTotalPages > 1) {
        <div class="list-pagination">
          <span class="pagination-info"
            >Side {{ maintenanceGroupsPageIndex + 1 }} af
            {{ maintenanceGroupsTotalPages }}</span
          >
          <button
            mat-button
            [disabled]="maintenanceGroupsPageIndex === 0"
            (click)="
              maintenanceGroupsPageIndex = maintenanceGroupsPageIndex - 1
            "
          >
            Forrige
          </button>
          <button
            mat-button
            [disabled]="
              maintenanceGroupsPageIndex >= maintenanceGroupsTotalPages - 1
            "
            (click)="
              maintenanceGroupsPageIndex = maintenanceGroupsPageIndex + 1
            "
          >
            Næste
          </button>
        </div>
        } } @if (!loadingMaintenance && maintenanceByModule.length === 0) {
        <p class="empty-message">
          @if (maintenanceItems.length === 0) { @if (!filterActiveOnly) { Ingen
          vedligeholdelsesmoduler tilknyttet denne version. Brug "+ Tilføj
          vedligeholdelse" ovenfor. } @if (filterActiveOnly) { Ingen moduler er
          aktive i rul. } } @if (maintenanceItems.length > 0)
          { @if (!filterActiveOnly) { Ingen vedligeholdelsesperioder overlapper
          {{ viewRollSummaryLabel }}. Vælg et andet år eller tilføj perioder. }
          @if (filterActiveOnly) { Ingen vedligeholdelse overlapper rul og er
          samtidig aktiv i rul. } }
        </p>
        }
      </div>
    </mat-tab>
    <!-- ──── Krav ─────────────────────────────────────────────────────────── -->
    <mat-tab label="Krav">
      <div class="tab-content">
        <div class="toolbar">
          <button
            mat-raised-button
            color="primary"
            (click)="onAddRequirement()"
          >
            + Tilføj krav
          </button>
        </div>
        @if (loadingRequirements) {
        <p class="loading-message">Henter krav...</p>
        } @if (!loadingRequirements && requirementsByModule.length > 0) {
        <!-- Summary bar -->
        <div class="summary-bar">
          <span class="summary-count">
            {{ filteredRequirementsGroups.length }}
            @if (requirementsSearch) { af {{ requirementsByModule.length }} }
            krav{{ requirementsByModule.length === 1 ? "" : "" }}
          </span>
          @if (currentPeriodStart && currentPeriodEnd) {
          <span class="summary-active">
            · {{ requirementsActiveCount }} aktive i rul
          </span>
          }
          <div class="summary-actions">
            <button
              mat-button
              class="summary-btn"
              (click)="
                expandAll(filteredRequirementsGroups, expandedRequirements)
              "
            >
              Udvid alle
            </button>
            <button
              mat-button
              class="summary-btn"
              (click)="collapseAll(expandedRequirements)"
            >
              Fold alle ind
            </button>
          </div>
        </div>
        <!-- Search -->
        <div class="search-bar">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Søg i krav</mat-label>
            <input
              matInput
              [(ngModel)]="requirementsSearch"
              (ngModelChange)="onRequirementsSearchChange()"
              placeholder="Navn..."
            />
            @if (requirementsSearch) {
            <span
              matSuffix
              class="search-clear"
              (click)="requirementsSearch = ''; onRequirementsSearchChange()"
              >✕</span
            >
            }
          </mat-form-field>
        </div>
        @if (filteredRequirementsGroups.length === 0) {
        <p class="empty-message">
          Ingen krav matcher "{{ requirementsSearch }}".
        </p>
        } @for (group of paginatedRequirementsGroups; track trackByKey($index,
        group)) {
        <div
          class="module-group-card"
          [class.has-current-coverage]="group.hasCurrentPeriodCoverage"
        >
          <div
            class="group-header"
            (click)="toggleExpand(group.key, expandedRequirements)"
          >
            <div class="group-header-left">
              <span class="expand-icon">{{
                isExpanded(group.key, expandedRequirements) ? "▾" : "▸"
              }}</span>
              <span class="group-name">{{ group.name }}</span>
              <span class="type-chip">{{ group.type }}</span>
              @if (group.hasCurrentPeriodCoverage) {
              <span class="active-chip">Aktiv nu</span>
              }
            </div>
            @if (groupItemDescriptionText(group); as descText) {
            <div class="group-header-meta">
              <span class="group-header-desc" [title]="descText">{{
                descText
              }}</span>
            </div>
            }
            <div class="group-header-right">
              <ng-container
                *ngTemplateOutlet="coverageChips; context: { $implicit: group }"
              ></ng-container>
              <span class="entry-count"
                >{{ group.entries.length }}
                {{ group.entries.length === 1 ? "periode" : "perioder" }}</span
              >
            </div>
          </div>
          @if (isExpanded(group.key, expandedRequirements)) {
          <div class="entries-list">
            @for (row of group.entries; track trackById($index, row)) {
            <div
              class="entry-row"
              [class.entry-active]="
                isActiveInCurrentPeriod(row.start_date, row.end_date)
              "
            >
              @if (editingRequirementId !== row.id) {
              <div class="entry-info">
                @if (isActiveInCurrentPeriod(row.start_date, row.end_date)) {
                <span class="entry-active-dot" title="Aktiv i rul"
                  >●</span
                >
                }
                <span class="entry-dates">{{
                  formatDateRange(row.start_date, row.end_date)
                }}</span>
              </div>
              <div class="entry-actions">
                <button
                  mat-button
                  class="btn-edit"
                  (click)="openEditRequirement(row, group.key)"
                >
                  Rediger
                </button>
                <button
                  mat-button
                  class="btn-remove"
                  (click)="removeRequirement(row)"
                >
                  Fjern
                </button>
              </div>
              } @else {
              <div class="inline-edit-form">
                <mat-form-field appearance="outline" class="date-field">
                  <mat-label>Start dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="editRequirementForm.start_date"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="date-field">
                  <mat-label>Slut dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="editRequirementForm.end_date"
                  />
                </mat-form-field>
                <div class="form-actions">
                  <button mat-button (click)="cancelEditRequirement()">
                    Annuller
                  </button>
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="saveEditRequirement()"
                  >
                    Gem
                  </button>
                </div>
              </div>
              }
            </div>
            }
          </div>
          <div class="inline-add-section">
            @if (addingReqPeriodForKey === group.key) {
            <div class="inline-add-form">
              <span class="inline-add-label"
                >Ny periode for <strong>{{ group.name }}</strong></span
              >
              <mat-form-field appearance="outline" class="date-field">
                <mat-label>Start dato</mat-label>
                <input
                  matInput
                  type="date"
                  [(ngModel)]="inlineAddReqForm.start_date"
                  required
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="date-field">
                <mat-label>Slut dato</mat-label>
                <input
                  matInput
                  type="date"
                  [(ngModel)]="inlineAddReqForm.end_date"
                />
              </mat-form-field>
              <div class="form-actions">
                <button mat-button (click)="cancelInlineAddRequirement()">
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="
                    !inlineAddReqForm.start_date || savingInlineAddReq
                  "
                  (click)="saveInlineAddRequirement(group)"
                >
                  {{ savingInlineAddReq ? "Gemmer..." : "Tilføj periode" }}
                </button>
              </div>
            </div>
            } @else {
            <button
              mat-button
              class="add-period-btn"
              (click)="openInlineAddRequirement(group)"
            >
              + Tilføj periode for dette krav
            </button>
            }
          </div>
          }
        </div>
        }
        <!-- Pagination (Krav) -->
        @if (requirementsGroupsTotalPages > 1) {
        <div class="list-pagination">
          <span class="pagination-info"
            >Side {{ requirementsGroupsPageIndex + 1 }} af
            {{ requirementsGroupsTotalPages }}</span
          >
          <button
            mat-button
            [disabled]="requirementsGroupsPageIndex === 0"
            (click)="
              requirementsGroupsPageIndex = requirementsGroupsPageIndex - 1
            "
          >
            Forrige
          </button>
          <button
            mat-button
            [disabled]="
              requirementsGroupsPageIndex >= requirementsGroupsTotalPages - 1
            "
            (click)="
              requirementsGroupsPageIndex = requirementsGroupsPageIndex + 1
            "
          >
            Næste
          </button>
        </div>
        } } @if (!loadingRequirements && requirementsByModule.length === 0) {
        <p class="empty-message">
          @if (requirementItems.length === 0) { @if (!filterActiveOnly) { Ingen
          krav tilknyttet denne version. Brug "+ Tilføj krav" ovenfor. } @if
          (filterActiveOnly) { Ingen krav er aktive i rul. } }
          @if (requirementItems.length > 0) { @if (!filterActiveOnly) { Ingen
          krav overlapper {{ viewRollSummaryLabel }}. Vælg et andet år eller
          tilføj perioder. } @if (filterActiveOnly) { Ingen krav overlapper rul og er
          samtidig aktive i rul. } }
        </p>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
} @if (!versionId) {
<div class="no-version">
  <p>Vælg en version for at se og administrere moduler.</p>
</div>
}

<!-- Compact coverage chips: consecutive years are ranges; selected + calendar year stay individual -->
<ng-template #coverageChips let-group>
  <div class="year-chips" (click)="$event.stopPropagation()">
    @for (seg of group.coverageDisplay; track trackByCoverageSegment($index,
    seg)) {
    <span
      class="year-chip"
      [class.covered]="seg.covered"
      [class.gap]="!seg.covered"
      [class.current-year]="seg.isCurrent"
      [class.calendar-year]="seg.isCalendarYear"
      [class.range]="seg.startYear !== seg.endYear"
      [title]="seg.title"
    >
      {{ seg.label }}{{ seg.covered ? " ✓" : " !" }}
    </span>
    }
  </div>
</ng-template>
